'use client';

import React, { useState } from 'react';
import {
  LOGIN_LOGO_MAX_HEIGHT_PX,
  LOGIN_LOGO_MAX_WIDTH_PX,
  LOGIN_LOGO_SRC,
} from '@/constants/branding';

const LoginLogo: React.FC = () => {
  const [loaded, setLoaded] = useState(false);

  return (
    <div
      style={{
        width: '100%',
        maxWidth: LOGIN_LOGO_MAX_WIDTH_PX,
        height: LOGIN_LOGO_MAX_HEIGHT_PX,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '0 auto 16px',
      }}
    >
      <img
        src={LOGIN_LOGO_SRC}
        alt="FSM Tech App"
        onLoad={() => setLoaded(true)}
        style={{
          maxWidth: '100%',
          maxHeight: '100%',
          width: 'auto',
          height: 'auto',
          objectFit: 'contain',
          opacity: loaded ? 1 : 0,
          transition: 'opacity 0.35s ease-in',
        }}
      />
    </div>
  );
};

export default LoginLogo;
